import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationModel } from '@shared/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  name: 'localization',
  pure: false,
  standalone: true,
})
export class LocalizationPipe implements PipeTransform {
  constructor(private readonly service: LocalizationService) {}

  transform(value: LocalizationModel | any | undefined, args?: NonNullable<unknown>): string {
    if (value == null) {
      return '';
    }
    if (typeof value === 'string') {
      return this.service.transform(value, args) ?? value;
    }
    if (typeof value === 'number') {
      return value + '';
    }
    if (typeof value === 'boolean') {
      return this.service.transform(value + '', args) || value + '';
    }
    if (typeof value === 'object') {
      return value[this.service.currentLanguage]
        ? value[this.service.currentLanguage] ?? ''
        : (value['ru'] || value['kz']) ?? '';
    }
    return '';
  }
}
